import React from 'react';
import Input from '../elements/Input';

const HealthcareInformationForm = ({ formData, setFormData, formError }) => (
  <>
    <Input
      label="Medical Condition / History"
      value={formData.medicalHistory || ''}
      onChange={e => setFormData({ ...formData, medicalHistory: e.target.value })}
      placeholder="e.g. Type 2 Diabetes, Hypertension, Asthma"
      error={formError.medicalHistory}
    />
    <Input
      label="Current Medications"
      value={formData.medications || ''}
      onChange={e => setFormData({ ...formData, medications: e.target.value })}
      placeholder="e.g. Metformin 500mg, Aspirin 75mg, Inhaler"
      error={formError.medications}
    />
    <Input
      label="Doctor / Provider Name"
      value={formData.provider || ''}
      onChange={e => setFormData({ ...formData, provider: e.target.value })}
      placeholder="e.g. Dr. Mehta, Apollo Hospital, Fortis Clinic"
      error={formError.provider}
    />
    <Input
      label="Provider Contact"
      type="tel"
      value={formData.providerContact || ''}
      onChange={e => setFormData({ ...formData, providerContact: e.target.value })}
      placeholder="e.g. +91-9876543210, 022-12345678"
      error={formError.providerContact}
    />
    <Input
      label="Notes / Details"
      type="textarea"
      value={formData.notes || ''}
      onChange={e => setFormData({ ...formData, notes: e.target.value })}
      placeholder="Enter any additional notes or details"
      error={formError.notes}
    />
  </>
);

export default HealthcareInformationForm;